import { put, takeEvery } from 'redux-saga/effects'
import {
  LOAD_OUTBOUNDDATA_ERROR,
  LOAD_OUTBOUNDDATA_LOADING,
  LOAD_OUTBOUNDDATA_SUCCESS,
} from './actions'
import Api from './api'

async function fetchAsync(func) {
  const response = await func()

  if (response.ok) {
    return await response.json()
  }

  throw new Error('Unexpected error!!!')
}

function* fetchSummary() {
  try {
    const outboundData = yield fetchAsync(Api.getData)

    yield put({ type: LOAD_OUTBOUNDDATA_SUCCESS, data: outboundData })
  } catch (e) {
    yield put({ type: LOAD_OUTBOUNDDATA_ERROR, error: e.message })
  }
}

export function* exceptionSaga() {
  yield takeEvery(LOAD_OUTBOUNDDATA_LOADING, fetchSummary)
}

export default exceptionSaga
